import { useUnit } from 'effector-react'

import {
  screenOpened,
  userIdentified,
  userPropertiesUpdated
} from 'analytics.model'
import { analyticsService } from '../features/analytics.service'

export function useIdentify() {
  const { identify } = useUnit({ identify: userIdentified })

  return { identify }
}

export function useScreenCapture() {
  const { onScreenOpened } = useUnit({ onScreenOpened: screenOpened })

  return { screenOpened: onScreenOpened }
}

export function useAnalytics() {
  return { capture: analyticsService.capture }
}

export function useUserProperties() {
  const { setUserProperties } = useUnit({
    setUserProperties: userPropertiesUpdated
  })

  return { setUserProperties }
}
